import { useState } from 'react';
import { useAsync } from 'react-use';
import { getCatalog } from '../../data-layer/catalogs/service';
import { showNotificationAsync } from '../../data-layer/notifications/actions';
import { useDispatch } from '../../data-layer/useDispatch';
import { useTranslation } from '../../utils/useTranslation';
import type { CatalogModel } from '../../data-layer/catalogs/types';

export const useCatalog = (catalogId: string) => {
    const dispatch = useDispatch();
    const t = useTranslation();
    const [catalog, setCatalog] = useState<CatalogModel | undefined>();

    const { loading } = useAsync(async () => {
        try {
            setCatalog(await getCatalog(catalogId));
        } catch (error) {
            dispatch(showNotificationAsync(t('Не удалось загрузить каталог')));
            setCatalog(undefined);
        }
    }, [catalogId, dispatch, setCatalog]);

    return {
        catalog,
        isLoading: loading,
    };
};
